module.exports = __webpack_public_path__ + "img/2.f4f7dde8.jpg";